import commonEN from "./en/common"
import commonES from "./es/common"
import errorEN from "./en/error"
import errorES from "./es/error"
import footerEN from "./en/footer"
import footerES from "./es/footer"
import loginEN from "./en/login"
import loginES from "./es/login"
import poapEN from "./en/poap"
import poapES from "./es/poap"
import walletEN from "./en/wallet"
import walletES from "./es/wallet"

export const es = {
  common: commonES,
  error: errorES,
  footer: footerES,
  login: loginES,
  poap: poapES,
  wallet: walletES,
}

export const en = {
  common: commonEN,
  error: errorEN,
  footer: footerEN,
  login: loginEN,
  poap: poapEN,
  wallet: walletEN,
}
